import type { JSX } from 'react';
import { Box, Choicebox, FormGroup, FormSection } from '@ksyos/design-system';
import type { BariPreNurseSpecialistMedScreeningReportData } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/types';
import { useProcessActivityEditContext } from '@frontend/utils';
import { TextAreaFormGroup } from '../../processActivityFormGroupFields';
import { additionalExaminations } from './bariPreNurseSpecialistMedScreeningReportUtils';

export function BariPreNurseSpecialistMedScreeningReportAanvullendeOnderzoeken(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariPreNurseSpecialistMedScreeningReportData>();

    return (
        <FormSection title="Aanvullende onderzoeken">
            <FormGroup label="Aanvullende onderzoeken">
                <Box
                    display="flex"
                    flexWrap="wrap"
                    gap={3}
                >
                    {additionalExaminations.map((examination) => (
                        <Choicebox
                            checked={data[examination.fieldKey] ?? undefined}
                            key={examination.fieldKey}
                            label={examination.label}
                            name={examination.label}
                            onChange={() => handleChoiceboxChange(examination)}
                        />
                    ))}
                </Box>
            </FormGroup>
            {additionalExaminations
                .filter((examination) => data[examination.fieldKey])
                .map(({ fieldKey, label, textAreaFieldKey }) => (
                    <TextAreaFormGroup
                        fieldKey={textAreaFieldKey}
                        isRequired={true}
                        key={fieldKey}
                        label={`Toelichting ${label[0].toLowerCase() + label.slice(1)}`}
                    />
                ))}
        </FormSection>
    );

    function handleChoiceboxChange(examination: (typeof additionalExaminations)[number]): void {
        onChange(
            {
                [examination.fieldKey]: !data[examination.fieldKey] || null,
                [examination.textAreaFieldKey]: null,
            },
            examination.fieldKey
        );
    }
}
